module.exports = __webpack_public_path__ + "images/Allergy_SS_754979479_4c0bfd5.jpg";